import { Box } from '@veracity/vui'

import { PageContainer, PageSearchInput } from '@/components'
import { useCurrentUser, useFilterDatasets } from '@/hooks'

import {
  AddWholesaleMarketDatasetDialog,
  WholesaleMarketDatasetsTable
} from './components'
import { useWholesaleMarketDatasets } from './hooks'

export const WholesaleMarketPage = () => {
  const { isUser } = useCurrentUser()
  const { wholesaleMarketDatasets, isFetching } = useWholesaleMarketDatasets()

  const { filteredDatasets, onFilterChange } = useFilterDatasets(
    wholesaleMarketDatasets
  )

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs
          items={[{ title: 'Library' }, { title: 'Wholesale market' }]}
        />
      }
      menuBar={
        <Box justify="space-between" w="100%">
          <PageSearchInput onChange={onFilterChange} />
          {isUser && <AddWholesaleMarketDatasetDialog />}
        </Box>
      }>
      <WholesaleMarketDatasetsTable datasets={filteredDatasets} />
    </PageContainer>
  )
}
